/**
 * Configured and downloaded from https://ckeditor.com/ckeditor-5/online-builder/
 */
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
require('./ckeditor');
import {UploadAdapterClass} from "./_uploadAdapter";

window.CKEDITOR = ClassicEditor;
CKEDITOR.config = {
    toolbar: {
        items: [
            'undo',
            'redo',
            'heading',
            'fontFamily',
            'fontSize',
            '|',
            'fontColor',
            'fontBackgroundColor',
            'highlight',
            'bold',
            'underline',
            'superscript',
            'subscript',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'indent',
            'alignment',
            'outdent',
            '|',
            //'imageUpload',
            //'uploadImage',
            'imageInsert',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            '|',
            'specialCharacters',
            'horizontalLine',
            'code',
            'codeBlock',
            //'exportPdf',
            //'exportWord'
        ],
        shouldNotGroupWhenFull: true
    },

    image: {
        // Configure the available styles.
        styles: [
            'alignLeft', 'alignCenter', 'alignRight'
        ],

        // Configure the available image resize options.
        resizeOptions: [ {
                name: 'imageResize:original',
                label: 'Original',
                value: null
            }, {
                name: 'imageResize:25',
                label: '25%',
                value: '25'
            }, {
                name: 'imageResize:50',
                label: '50%',
                value: '50'
            }, {
                name: 'imageResize:75',
                label: '75%',
                value: '75'
            }
        ],

        toolbar: [
            'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
            '|',
            'imageResize',
            '|',
            'imageTextAlternative'
        ]
    },

    link: {
        decorators: {
            isExternal: {
                mode: 'manual',
                label: 'Open in a new tab',
                attributes: {
                    target: '_blank'
                }
            },
            // toggleDownloadable: {
            //     mode: 'manual',
            //     label: 'Downloadable',
            //     attributes: {
            //         download: 'file'
            //     }
            // },
        }
    },

    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
        ]
    },

    language: 'en',
    licenseKey: '',
    extraPlugins: [
        UploadAdapterPlugin,
    ],
};

/**
 * Create the upload adapter plugin
 */
function UploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new UploadAdapterClass(loader);
    };
}
